module.exports = __webpack_public_path__ + "static/img/Kenny-Bromwich.fdc8d6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kenny-Bromwich.jpg
// module id = n6Jp
// module chunks = 0